import { render, staticRenderFns } from "./SettingsBillingPlans.vue?vue&type=template&id=45e579d4&scoped=true&"
import script from "./SettingsBillingPlans.vue?vue&type=script&lang=js&"
export * from "./SettingsBillingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e579d4",
  null
  
)

export default component.exports